import { getSubdomainFromHostname } from 'shared/tools/url-helper'

export const FREE_HOLIDAY_BOOKS_PROMO_CODE = 'FREEHOLIDAYBOOKS26'

/** Set to false to disable shelf redirect / follow for this promo. */
export const FREE_HOLIDAY_BOOKS_PROMO_ENABLED = true

export const FREE_HOLIDAY_BOOKS_SHELVES_BY_LOCALE: Record<string, string> = {
  da: 'OIDkpL0R', // DK
  nl: 'sewnEh27', // NL, BE
  de: 'ajRwAyQl', // DE, AT, CH
  es: 'OmtRFNjo', // ES
  hu: 'plUscbWN', // HU
  en: 'IpiN6v1X', // UK, IE
}

export const FREE_HOLIDAY_BOOKS_COUNTRY_TO_LOCALE: Record<string, string> = {
  dk: 'da',
  nl: 'nl',
  be: 'nl',
  de: 'de',
  at: 'de',
  ch: 'de',
  es: 'es',
  hu: 'hu',
  gb: 'en',
  ie: 'en',
}

export function isFreeHolidayBooksPromo(code?: string | null): boolean {
  return (
    FREE_HOLIDAY_BOOKS_PROMO_ENABLED && code === FREE_HOLIDAY_BOOKS_PROMO_CODE
  )
}

function resolveLocaleGroup({
  country,
  host,
}: {
  country?: string
  host?: string
}): string | null {
  if (country) {
    const countryLocale =
      FREE_HOLIDAY_BOOKS_COUNTRY_TO_LOCALE[country.toLowerCase()]
    if (countryLocale) return countryLocale
  }

  const subdomain = host ? getSubdomainFromHostname(host) : ''
  if (subdomain && FREE_HOLIDAY_BOOKS_SHELVES_BY_LOCALE[subdomain]) {
    return subdomain
  }

  return null
}

export function resolveFreeHolidayBooksShelfUuid(params: {
  country?: string
  host?: string
}): string | null {
  const localeGroup = resolveLocaleGroup(params)
  if (!localeGroup) return null

  return FREE_HOLIDAY_BOOKS_SHELVES_BY_LOCALE[localeGroup] ?? null
}

export function extractShelfUuidFromPath(path: string): string | null {
  const match = path.match(/\/bookshelves\/([^/?]+)/)
  return match ? match[1] : null
}
